export default class OptionsFactory {
    // #region Vars
    _Host;
    // #endregion
    // #region Constructor
    constructor(host) {
        this._Host = host;
    }
    // #endregion
    // #region Get
    get(name, ...args) {
        // #region Args
        if (args.length > 0) {
            let tItem = args.find((e) => {
                if (!e) {
                    return false;
                }
                if (e[name] === undefined || e[name] === null) {
                    return false;
                }
                return true;
            });
            if (tItem !== undefined && tItem !== null) {
                return tItem[name];
            }
        }
        // #endregion
        // #region Session
        let tSessionOptions = this._Host?.session?.options;
        if (tSessionOptions && tSessionOptions[name] !== undefined && tSessionOptions[name] !== null) {
            return tSessionOptions[name];
        }
        // #endregion
        // #region Options
        let tOptions = this._Host.config.options;
        if (tOptions && tOptions[name] !== undefined && tOptions[name] !== null) {
            return tOptions[name];
        }
        // #endregion
        return null;
    }
}
